import { PropsWithChildren, useState } from "react"

import ErrorModal from "@/globalComponents/organisms/ErrorModal"

import { ErrorModalContext } from "./useErrorModal"

export function ErrorModalProvider({ children }: PropsWithChildren) {
  const [error, setError] = useState<{
    error: Error
    onClose?: () => void
  } | null>(null)

  return (
    <ErrorModalContext.Provider value={{ setError }}>
      {children}
      <ErrorModal error={error?.error} onOpenChange={handleCleanup} />
    </ErrorModalContext.Provider>
  )

  function handleCleanup(isOpen: boolean) {
    if (!isOpen) {
      error?.onClose?.()
      setError(null)
    }
  }
}
